import jwt_decode from "jwt-decode";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";

export const actionAccess = {
  GLOG_FUNCTION_BUS_ADD: "GLOG_FUNCTION_BUS_ADD",
  GLOG_FUNCTION_BUS_VIEW: "GLOG_FUNCTION_BUS_VIEW",
  GLOG_FUNCTION_BUS_UPDATE: "GLOG_FUNCTION_BUS_UPDATE",
  GLOG_FUNCTION_BUS_ACTIVE: "GLOG_FUNCTION_BUS_ACTIVE",
  GLOG_FUNCTION_BUS_EXPORT: "GLOG_FUNCTION_BUS_EXPORT",

  GLOG_FUNCTION_MY_ORDER_ADD: "GLOG_FUNCTION_MY_ORDER_ADD",
  GLOG_FUNCTION_MY_ORDER_VIEW: "GLOG_FUNCTION_MY_ORDER_VIEW",
  GLOG_FUNCTION_MY_ORDER_EXPORT: "GLOG_FUNCTION_MY_ORDER_EXPORT",
  GLOG_FUNCTION_MY_ORDER_CLONE: "GLOG_FUNCTION_MY_ORDER_CLONE",
  GLOG_FUNCTION_MY_ORDER_CANCEL: "GLOG_FUNCTION_MY_ORDER_CANCEL",

  GLOG_FUNCTION_ORDER_ADD: "GLOG_FUNCTION_ORDER_ADD",
  GLOG_FUNCTION_ORDER_VIEW: "GLOG_FUNCTION_ORDER_VIEW",
  GLOG_FUNCTION_ORDER_ASSIGN: "GLOG_FUNCTION_ORDER_ASSIGN",
  GLOG_FUNCTION_ORDER_STATUS: "GLOG_FUNCTION_ORDER_STATUS",
  GLOG_FUNCTION_ORDER_CANCEL: "GLOG_FUNCTION_ORDER_CANCEL",
  GLOG_FUNCTION_ORDER_EXPORT: "GLOG_FUNCTION_ORDER_EXPORT",
  GLOG_FUNCTION_ORDER_CHANGE_CUSTOMER: "GLOG_FUNCTION_ORDER_CHANGE_CUSTOMER",

  GLOG_FUNCTION_NOTIFICATION_VIEW: "GLOG_FUNCTION_NOTIFICATION_VIEW",
};

export const ROLE_APP = {
  ROLE_MSPLOGISTIC_GS_SALE: "_SALE", //ROLE_MSPLOGISTIC_GS_SALE ROLE_MSPLOGISTIC_HN_SALE
  ROLE_LOG_ADMIN: "ROLE_MSPLOGISTIC_GS_LOG_ADMIN",
  ROLE_LOG_ADMIN_ALIASES: ["ROLE_msplogistic_LOG_ADMIN"],
  ROLE_HUB_ADMIN: "ROLE_msplogistic_GS_HUB_ADMIN",
};

export const checkHaveToken = () => {
  if (localStorage.getItem(AUTH_TOKEN)) {
    return true;
  }
  return false;
};

export const getHomeLink = () => {
  if (!checkHaveToken()) {
    return "/login";
  }
  const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
  const listRole = info["auth"].split(",");
  if (listRole.find(item => item.includes(ROLE_APP.ROLE_MSPLOGISTIC_GS_SALE))) {
    return "/my-orders";
  } else {
    return "/dashboard";
  }
};

export const USER_TYPE = {
  LOG_AMDIN: 1,
  HUB_ADMIN: 4,
};
